<template>
  <div class="box">
    <div class="top f p-56 h-block c-white">
      <div class="img_box">
        <!-- <gNewImg
          src="bindMember"
          size="96"
          class="m-r-20"
        ></gNewImg> -->
        <img class="img_inner" :src="myImage" alt="" />
      </div>
      <div class="f-cl h-block bs">
        <div>
          <div class="">{{ userInfo.MemberName }}</div>
        </div>
        <!-- <div> -->
        <!-- <span>hi </span> -->
        <!-- <span>{{userInfo.MemberName}}, </span>
          今天有<span>{{nowSubscribeData.ordertotalperson || '--'}}</span>位客人预约了你 -->
        <!-- </div> -->
        <div v-if="JishiStatus">
          <button class="online" @click="duty">{{ JishiStatus }}</button>
        </div>
      </div>
      <!-- <gNewImg
        class="f-1 m-l-40"
        src="pull_rt_white.png"
        which="clock"
        size="18"
      ></gNewImg> -->
    </div>

    <div class="main">
      <div class="today_look">今日概览</div>
      <div class="f-bt line_box" @click="toClockDetail">
        <div class="circle_box f-ar">
          <div class="tc">
            <span class="yellow_num">{{
              nowClockData.clocktotalcount || 0
            }}</span>
            <span>
              次
            </span>
            <div class="m-t-10">做钟次数</div>
          </div>
        </div>
        <div class="clock_box f f-4 m-lr-20 p-10 bs tc">
          <div v-for="(v, i) in clockList" :key="i" class="clock_item">
            <div :class="'doit' + i">
              <span>
                {{ v.clocktype }}
              </span>
              <span>
                {{ v.count }}
              </span>
            </div>
          </div>
        </div>
        <gNewImg class="f-1 m-l-40" src="pull_rt.png" size="6"></gNewImg>
      </div>
      <div
        class="f-bt line_box"
        @click="toCommisionDetail"
        v-if="!isDisableJishiPersumeInfo"
      >
        <div class="circle_box f-ar ">
          <div class="tc">
            <span class="blue_num">{{
              (nowAData.persume_total && nowAData.persume_total.totalpersume)
                | toMoney
            }}</span>
            <div class="m-t-10">提成金额</div>
          </div>
        </div>
        <div class="f-4 m-lr-20 clock_box f p-10 bs tc">
          <div class="get_box f-cl">
            <div>做钟提成</div>
            <div>
              {{ $pub.handleMoney(nowAData && nowAData.persume_clock_total) }}
            </div>
          </div>
          <div class="get_box f-cl">
            <div>商品提成</div>
            <div>
              {{
                (nowAData.persume_goods_total &&
                  nowAData.persume_goods_total.amount) | toMoney
              }}
            </div>
          </div>
          <div class="get_box f-cl">
            <div>售卡提成</div>
            <div>
              {{ $pub.handleMoney(nowAData && nowAData.persume_card_total) }}
            </div>
          </div>
        </div>
        <gNewImg class="f-1 m-l-40" src="pull_rt.png" size="6"></gNewImg>
      </div>
    </div>

    <template v-if="!isDisableJishiPersumeInfo">
      <gLine color="#eee" size="20"></gLine>
      <gTimeComp
        :sTime.sync="startTime"
        :eTime.sync="endTime"
        @click="timeChange"
      ></gTimeComp>

      <div class="bottom f-bt" @click="toAll">
        <div class="item p-24 br-8 f-cl">
          <div class="btm_top m-r-10">做钟次数</div>
          <div class="f-ar">
            <span class="font-40 tc ">{{
              (aData.persume_clock_total && aData.persume_clock_total.count) ||
                0
            }}</span>
            <span>
              次
            </span>
          </div>
        </div>
        <div class="item p-24 br-8 f-cl item2">
          <div class="btm_top tc">提成金额</div>
          <div>
            <span class="font-40 tc f-ar">{{
              (aData.persume_total && aData.persume_total.totalpersume)
                | toMoney
            }}</span>
          </div>
        </div>
        <!-- <div class="item p-24 br-8 f-cl item3">
        <div class="btm_top">预约人数</div>
        <div class="f-ar">
          <span class="font-40 tc ">{{
            subscribeData.ordertotalperson || "--"
          }}</span>
          <span>人</span>
        </div>
      </div> -->
        <gNewImg src="pull_rt.png" size="6"></gNewImg>
      </div>
    </template>
    <gLogoBottom></gLogoBottom>
  </div>
</template>

<script>
import { getpersumestatistics, getclockstatistics, getjishicode, jishiDuty } from "@/api/Jishi";
import { mapState } from "vuex";
export default {
  name: "JiShiReportHome",
  props: {},
  data() {
    return {
      isDisableJishiPersumeInfo: true,
      topList: ["做种详情", "提成详情", "预约详情"],
      isSelected: "",
      active: "",
      aData: {},
      clockData: {},
      subscribeData: {},
      nowAData: {},
      nowClockData: {},
      nowSubscribeData: {},
      clockList: [
        { clocktype: "排钟", count: 0 },
        { clocktype: "点钟", count: 0 },
        { clocktype: "选钟", count: 0 },
        { clocktype: "加钟", count: 0 },
        { clocktype: "退钟", count: 0 },
        { clocktype: "旷钟", count: 0 }
      ],
      originParams: {},
      startTime: "",
      endTime: "",
      userInfo: {},
      myImage: "",
      isLock: false,
      JishiStatus: '',
      JishiCodes: ''
    };
  },
  computed: {},
  components: {},
  async created() {
  },
  mounted() {
    this.jishicode()
  },
  methods: {
    duty() {
    //   const params = {
    //     JiShiCode: this.JishiCodes,
    //     DutyType: this.JishiStatus
    //   }
    //   this.newPost(this, 'jishi/duty', params).then(res => {
    //     console.log(res, '上下班打卡')
    //     this.$vux.toast.show({
    //       text: "操作成功",
    //       type: "success"
    //     });
    //   }).finally(() => {
    //   // 这里可以在任何情况下（成功或失败）都执行的操作
    //   this.jishicode();
    // });
    },
    async jishicode() {
    // const { JishiCode, Status } = await this.newGet(this, "jishi/jishicode");
    // console.log(JishiCode, Status, '666上下班返回值')
    // this.JishiStatus = Status !== '上班' ? '上班' : '下班';
    // this.JishiCodes = JishiCode;
    // if (JishiCode) {
    //   // jishiRes = '011'
    //   temporaryStorage.set("jsCode", JishiCode);
    //   if (!this.isLock) {
    //     this.timeChange();
    //   }
    // } else {
    //   return this.$vux.toast.text("技师编号为空", "middle");
    // }
    // this.getSetting();
    // this.getUserInfo();
    // const today = this.$pub.parseTime(new Date(), "{y}-{m}-{d}");
    // clockHttp(this, today).then(res => {
    //   this.nowClockData = res.data;
    //   this.clockList = this.clockList.map(v => {
    //     this.nowClockData.lst_clock_total.forEach(val => {
    //       if (v.clocktype === val.clocktype) {
    //         v.count = val.count;
    //       }
    //     });
    //     return v;
    //   });
    // });
    },
    getSetting() {
      // 获取后台参数--是否禁用技师查看提成功能
      // postParameterSetting().then(res => {
      //   this.isDisableJishiPersumeInfo = res.DisableJishiViewPersume;
      //   if (!this.isDisableJishiPersumeInfo) {
      //     const today = this.$pub.parseTime(new Date(), "{y}-{m}-{d}");
      //     calcHttp(this, today).then(res => {
      //       if (res.errmsg === "ok") {
      //         this.nowAData = res.data;
      //       }
      //     });
      //   }
      // });
    },
    // isTest() {
    //   this.newGet(this, 'token/lineupstatus').then(res => {
    //     console.log('res', res)
    //   }).finally(err => {
    //     console.log(`22222***** err ***** 231行 ~/jinguiProject/wxweb-vue-main/src/pages/technician/technicianHome.vue  14:42:53`);
    //     console.log(err);
    //   })
    // },
    getUserInfo() {
      // this.newGet(this, "customer/profile/need").then(res => {
      //   this.userInfo = res;
      //   if (res.PhotoImg) {
      //     this.myImage = "data:image/png;base64," + res.PhotoImg;
      //   } else if (res.PhotoWechatUrl) {
      //     this.myImage = res.PhotoWechatUrl;
      //   } else {
      //     this.myImage = require("../../../static/image/Headportrait@2x.png");
      //   }
      // });
    },
    toAll() {
      this.$router.push("/technician/technicianAll");
    },
    // toSubscribe() {
    //   this.$router.push("/technician/subscribeDetail");
    // },
    toCommisionDetail() {
      this.$router.push("/technician/commissionDetail");
    },

    timeChange() {
      console.log("时间改变事件");
      if (!temporaryStorage.get("jsCode")) {
        return;
      }
      this.isLock = true;
      // clockHttp(this, this.startTime, this.endTime).then(res => {
      //   if (res.errmsg === "ok") {
      //     this.clockData = res.data;
      //   }
      // });
      if (!this.isDisableJishiPersumeInfo) {
        // calcHttp(this, this.startTime, this.endTime).then(res => {
        //   if (res.errmsg === "ok") {
        //     this.aData = res.data;
        //   }
        // });
      }
      // subscribeHttp(this, this.startTime, this.endTime).then(res => {
      //   if (res.errmsg === 'ok') {
      //     this.subscribeData = res.data;
      //   }
      // })
    },
    toClockDetail() {
      this.$router.push("/technician/clockDetail");
    },
    clickBtn() {
      this.$router.push("/technician/technicianSubscribe");
    },
    topHandler() {}
  }
};
</script>
<style scoped lang="scss">
.online{
  width: 14.667vw;
    border: 1px solid #aed7ae;
    height: 7vw;
    background: #d1e6ed;
    float: right;
    border-radius: 5px;
}
@mixin prefix-doit($color: blue) {
  position: relative;
  padding-left: 24px;
  &:after {
    content: " ";
    position: absolute;
    left: 0px;
    top: 14px;
    width: 10px;
    height: 10px;
    background-color: $color;
    border-radius: 50%;
  }
}

.top {
  background: lightblue;
}
.box {
  width: 100%;
  font-size: 24px;
  color: #666666;
  font-family: PingFangSC-Regular, PingFang SC;
}
.main {
  // height: 432px;
  background: #ffffff;
  color: #333;
  // box-shadow: 0px 1px 0px 0px rgba(222, 222, 222, 0.5);
  border-radius: 32px 32px 0px 0px;
  margin-top: -30px !important;
  padding: 32px !important;
  .line_box {
    width: 100%;
    margin: 40px;
  }
  .today_look {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .circle_box {
    width: 140px;
    height: 140px;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0px 0px 20px 0px rgba(221, 221, 221, 0.5);
    .yellow_num {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffbf00;
    }
    .blue_num {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #25a4ff;
    }
  }
  .clock_box {
    // background: #f6f6f6;
    background: #f6f6f6;
    flex-wrap: wrap;
    border-radius: 16px;
    min-height: 140px;
    .clock_item {
      width: 30%;
      margin: 10px 0;
      margin-left: 10px;
      box-sizing: border-box;
    }
    .get_box {
      width: 30%;
      height: 100px;
      margin: 10px 0;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }
}

.bottom {
  margin: 40px;
  box-sizing: border-box;
  .item {
    box-sizing: border-box;
    width: 160px;
    height: 160px;
    background: linear-gradient(180deg, #4bb7ba 0%, #5fc4c9 100%);
    box-shadow: 0px 5px 12px 0px rgba(157, 157, 157, 0.5);
    border-radius: 8px;
    color: #fff;
  }
  .item2 {
    background: linear-gradient(180deg, #6564ff 0%, #7777ff 100%);
    min-width: 0;
    flex: 1;
    margin: 0 20px;
    // width: 280px;
    height: 160px;
    font-size: 24px !important;
  }
  .item3 {
    background: linear-gradient(180deg, #f36940 0%, #ef8873 100%);
  }
}

.doit0 {
  @include prefix-doit(#1890ff); // 排钟
}
.doit1 {
  @include prefix-doit(#ff9570); // 点钟
}
.doit2 {
  @include prefix-doit(#ffc53d); // 选钟
}
.doit3 {
  @include prefix-doit(#52c41a); // 加钟
}
.doit4 {
  @include prefix-doit(#780650); // 退钟
}
.doit5 {
  @include prefix-doit(#f5222d); // 旷钟
}
.img_box {
  width: 96px;
  height: 96px;
  margin-right: 20px;
  box-sizing: border-box;
  .img_inner {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>
